import {createSlice} from "@reduxjs/toolkit"
// import { add } from "date-fns"


const InitialState = {
    product:[]
}

export const productsSlice = createSlice({
    name:"product",
    initialState:InitialState,
    reducers:{
        addAllProducts:(state,action)=>{
            state.product = action.payload
        },
        addProduct:(state,action)=>{
            state.product.push(action.payload)
        },
        updateProduct: (state, action) => {
  const updatedProduct = action.payload;
  const productIndex = state.product.findIndex(vendor => vendor._id === updatedProduct._id);
  if (productIndex !== -1) {
    state.product[productIndex] = {
      ...state.product[productIndex],
      ...updatedProduct
    };
  }
}
    }
})



export const {addAllProducts,addProduct,updateProduct} = productsSlice.actions

export default productsSlice.reducer